import { NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TFMService } from 'app/mock-api/tfm.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-capture-confirmation',
  standalone: true,
  imports: [FormsModule,NgIf],
  templateUrl: './capture-confirmation.component.html',
  styleUrl: './capture-confirmation.component.scss'
})
export class CaptureConfirmationComponent {

   public view : any = {
      // service: {
      //   supplier: '',
      //   service: '',
      //   cost: null,
      //   exchangeRateCurrent: null,
      //   price: null,
      //   start: null,
      //   end: null,
      //   adultCount: null,
      //   teenCount: null,
      //   childCount: null,
      //   infantCount: null,
      //   internalNote: '',
      //   chk1: false
      // }
    };
  user: any;
  
    constructor(public tfmService: TFMService,public dialogRef: MatDialogRef<CaptureConfirmationComponent>, @Inject(MAT_DIALOG_DATA) public data:any,private dialog: MatDialog){
      this.tfmService.getLoggedInUser().subscribe(res => {
        this.user = res;
      });
      this.view.service = this.data;
      console.log(this.view.service)
  
    }
    saveServiceItem() {
      if (this.view.service) {
        console.log("Save service item", this.view.service);
  
        if (this.view.service.id > 0) {
          this.tfmService.filterAndSend(this.view.service._links, "edit", this.view.service).subscribe(res => {
            console.log("Service updated");
            this.dialogRef.close();
            this.openConfirmationModal({
              title: 'Service updated',
              message: 'The service has been updated successfully',
              showClose: true,
              showViewQuotes: false,
              showNewQuote: false
            });
  
            // this.itinOptionsLoad();
          });
        }
        else {
          if (this.view.guid) {
            this.view.service.searchType = 1;
            this.tfmService.getItin(this.view.guid).subscribe(res => {
              let link = this.tfmService.getLink(res.content.itinerary._links, "add-item-custom");
              link.href = link.href.replace("{itineraryId}", res.content.itinerary.id);
              this.tfmService.send(link, this.view.service).subscribe(res => {
                this.dialogRef.close();
                this.openConfirmationModal({
                  title: 'Service updated',
                  message: 'The service has been updated successfully',
                  showClose: true,
                  showViewQuotes: false,
                  showNewQuote: false
                });
                //this.tripPointsGet();
                // this.itinOptionsLoad();
                console.log("Service added to itinerary");
              });
            });
          }
        }
      }
    }
    close(): void {
      this.dialogRef.close();
    }
    openConfirmationModal(config?: { title?: string; message?: string; showClose?: boolean; showViewQuotes?: boolean; showNewQuote?: boolean;}) {
      this.dialog.open(ConfirmationDialogComponent, {
        data: config
      });
    }


}
